/* ============
 * Organization Member Module
 * ============
 */

import state from './state';
import mutations from './mutations';

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMemberProductBusinesshour/index.js